import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { MagritteNotificationName } from 'utils/constants/notification';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const updateUser =
    (
        setLoad: (isLoad: boolean) => void,
        personalManagerId: string,
        personalManagerEmail: string,
        useHHManager: boolean
    ): AppThunkAction<void> =>
    (dispatch, getState) => {
        setLoad(true);

        const { userId } = getState().userDetail;
        const body = {
            id: userId,
            personalManagerId,
            personalManagerEmail,
            useHHManager,
        };

        fetcher
            .post(`/api/v1/backoffice/users/`, body)
            .then(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.UsersPageUpdateUserData));
                dispatch(push(`/new/admin/users/${userId}/`));
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.UsersPageErrorUpdateUserData));
            })
            .finally(() => {
                setLoad(false);
            });
    };
